module.exports = __webpack_public_path__ + "static/media/sajid.83715e81.png";